'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = require('preact');

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
var PushRecommendations = function (_Component) {
  (0, _inherits3.default)(PushRecommendations, _Component);

  function PushRecommendations(props) {
    (0, _classCallCheck3.default)(this, PushRecommendations);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PushRecommendations.__proto__ || Object.getPrototypeOf(PushRecommendations)).call(this, props));

    _this.state = {
      loadingRecommendations: false,
      recommendations: []
    };

    _this.fetchRecommendations = _this.fetchRecommendations.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PushRecommendations, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.mostRecentlyAddedItemProductId !== this.props.mostRecentlyAddedItemProductId) {
        this.fetchRecommendations();
      }
    }
  }, {
    key: 'fetchRecommendations',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var productId, url, response, data, cartProductIds, maxRecs, filteredProducts;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.items.length === 0)) {
                  _context.next = 3;
                  break;
                }

                this.removeExistingRecommendations();
                return _context.abrupt('return');

              case 3:
                productId = this.props.mostRecentlyAddedItemProductId;

                if (productId) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:

                this.setState({ loadingRecommendations: true });

                url = window.Shopify.routes.root + 'recommendations/products?product_id=' + productId + '&limit=8&section_id=product-recommendations';
                _context.prev = 8;
                _context.next = 11;
                return fetch(url, {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                  }
                });

              case 11:
                response = _context.sent;
                _context.next = 14;
                return response.json();

              case 14:
                data = _context.sent;

                if (data.products && data.products.length > 0) {
                  cartProductIds = new Set(this.props.items.map(function (item) {
                    return item.product_id;
                  }));
                  maxRecs = this.props.maxRecommendations || 4;
                  filteredProducts = data.products.filter(function (product) {
                    return !cartProductIds.has(product.id);
                  }).slice(0, maxRecs);


                  this.setState({ recommendations: filteredProducts });
                  this.updateCartDrawer(true);
                } else {
                  this.removeExistingRecommendations();
                }
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](8);

                console.error('Error fetching recommendations:', _context.t0);
                this.removeExistingRecommendations();

              case 22:
                _context.prev = 22;

                this.setState({ loadingRecommendations: false });
                return _context.finish(22);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 18, 22, 25]]);
      }));

      function fetchRecommendations() {
        return _ref.apply(this, arguments);
      }

      return fetchRecommendations;
    }()
  }, {
    key: 'removeExistingRecommendations',
    value: function removeExistingRecommendations() {
      this.setState({ recommendations: [] });
      this.updateCartDrawer(false);
    }
  }, {
    key: 'updateCartDrawer',
    value: function updateCartDrawer(hasRecs) {
      var cartDrawer = (0, _functional.getElement)('.drw-Drawer-cart');
      if (cartDrawer) {
        if (hasRecs) {
          cartDrawer.setAttribute('data-has-recs', 'true');
        } else {
          cartDrawer.removeAttribute('data-has-recs');
        }
      }
    }
  }, {
    key: 'renderRecommendationSkeletons',
    value: function renderRecommendationSkeletons() {
      var maxRecs = this.props.maxRecommendations || 4;
      return (0, _preact.h)(
        _preact.Fragment,
        null,
        [].concat((0, _toConsumableArray3.default)(Array(maxRecs))).map(function (_, index) {
          return (0, _preact.h)(
            'div',
            { key: index, 'class': 'crt-Recommendation_Item-skeleton' },
            (0, _preact.h)('div', { 'class': 'crt-Recommendation_Image-skeleton' }),
            (0, _preact.h)('div', { 'class': 'crt-Recommendation_Title-skeleton' }),
            (0, _preact.h)('div', { 'class': 'crt-Recommendation_AddButton-skeleton' })
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render(props, state) {
      if (props.items.length === 0) {
        return null;
      }

      return (0, _preact.h)(
        'div',
        { className: 'crt-Recommended ' + props.className },
        (0, _preact.h)(
          'div',
          { className: 'crt-Recommendations' },
          (0, _preact.h)(
            'h3',
            { className: 'crt-Recommendations_Title' },
            props.className === 'crt-Recommended-mobile' ? props.translations.recommendedTitleMobile : props.translations.recommendedTitle
          ),
          (0, _preact.h)(
            'div',
            { className: 'crt-Recommendations_Items' },
            state.loadingRecommendations ? this.renderRecommendationSkeletons() : state.recommendations.map(function (product) {
              return (0, _preact.h)(
                'div',
                { key: product.id, 'class': 'crt-Recommendation_Item' },
                (0, _preact.h)(
                  'div',
                  { 'class': 'crt-Recommendation_Image' },
                  (0, _preact.h)('img', { src: product.featured_image, alt: product.title })
                ),
                (0, _preact.h)(
                  'div',
                  { 'class': 'crt-Recommendation_Title' },
                  (0, _preact.h)(
                    'h4',
                    null,
                    (0, _preact.h)(
                      'a',
                      {
                        href: product.url,
                        'class': 'crt-Recommendation_TitleLink'
                      },
                      product.title
                    )
                  )
                ),
                (0, _preact.h)(
                  'form',
                  {
                    'class': 'crt-Recommendation_Form js-AddToCart',
                    action: '/cart/add',
                    method: 'post',
                    enctype: 'multipart/form-data'
                  },
                  (0, _preact.h)('input', {
                    type: 'hidden',
                    name: 'id',
                    value: product.variants[0].id
                  }),
                  (0, _preact.h)('input', { type: 'hidden', name: 'quantity', value: '1' }),
                  (0, _preact.h)('input', {
                    type: 'hidden',
                    name: 'tiktok_content_name',
                    value: product.title
                  }),
                  (0, _preact.h)('input', {
                    type: 'hidden',
                    name: 'tiktok_price',
                    value: product.price / 100
                  }),
                  (0, _preact.h)('input', {
                    type: 'hidden',
                    name: 'tiktok_value',
                    value: product.price / 100
                  }),
                  (0, _preact.h)(
                    'button',
                    {
                      'class': 'btn-Secondary js-AddToCart_Submit crt-Recommendation_AddButton',
                      type: 'submit'
                    },
                    (0, _preact.h)(
                      'span',
                      {
                        className: 'crt-Recommendation_Price igPrice',
                        'data-product-id': product.id
                      },
                      (0, _functional.formatMoney)(product.price)
                    ),
                    (0, _preact.h)(
                      'span',
                      { 'class': 'crt-Recommendation_AddText' },
                      'Add'
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return PushRecommendations;
}(_preact.Component);

exports.default = PushRecommendations;